/**
 * @prettier
 */

import React from 'react';
import cx from 'classnames';
import styles from './styles.module.less';

const Text = ({ step, breadcrumbSteps }) => {
  const currentPosition = breadcrumbSteps.indexOf(step.key) + 1;
  return currentPosition ? (
    <div className={styles.stepCounter}>
      Step {currentPosition} of {breadcrumbSteps.length}
    </div>
  ) : null;
};

const Dots = ({ step, breadcrumbSteps }) => {
  return step && breadcrumbSteps.length ? (
    <div className={styles.dotsBox}>
      {breadcrumbSteps.map(key => (
        <div key={key} className={cx(styles.dot, { [styles.active]: key === step.key })} />
      ))}
    </div>
  ) : null;
};

export default { Text, Dots };
